import React from 'react';
import PropTypes from 'prop-types';
import { ATTACHMENTS } from 'newJs/config';
import { useAttachData } from 'providers/attachs-data';
import { useAttachsParams } from 'providers/attachs-params';
import { useAttachsState } from 'providers/attachs-state';
import Action from './Base';
import SaveAction from './Save';
import { useGlobalProps } from 'providers/global-props';
import useMessageStore from 'state/messageState';

const { CLICK_ACTIONS, VIEW_MODE } = ATTACHMENTS;
const {
    DOWNLOAD_ALL, PLAY, SAVE_TO_CONTACTS, SAVE_TO_FILES_ALL, SAVE_TO_FILES, SAVE_TO_FOTO, VIEW_AS_GRID, VIEW_CALENDAR, VIEW_IMAGE, VIEW_PDF, VIEW_ZIP,
} = CLICK_ACTIONS;

const ItemAction = (props) => {
    const { actionName, children, ...rest } = props;
    const { handleClick } = useAttachsParams();
    const emlData = useMessageStore((state) => state.emlData);
    const {attachments} = emlData;
    const { i18n: {attachments: i18n} } = useGlobalProps();
    const { isPreviewMode, setStateValue } = useAttachsState();
    const itemData = useAttachData();

    const handleDownloadClick = (e) => {
        e.stopPropagation();
        setStateValue('clickedItemData', itemData);
        const data = actionName === DOWNLOAD_ALL ? attachments : itemData;
        // console.log('handle click', actionName, data);
        handleClick(actionName, data);
    };

    const setViewMode = (e, modeName) => {
        e.stopPropagation();
        setStateValue('clickedItemData', itemData);
        setStateValue(modeName, true, true);
    };

    switch (actionName) {
    case (PLAY):
        return (
            <Action
                data-tip={i18n.play}
                onClick={(e) => setViewMode(e, 'playerMode')}
            >
                {children}
            </Action>
        );
    case (SAVE_TO_CONTACTS):
    case (SAVE_TO_FILES_ALL):
    case (SAVE_TO_FILES):
    case (SAVE_TO_FOTO):
        return (
            <SaveAction
                actionName={actionName}
                {...rest}
            >
                {children}
            </SaveAction>
        );
    case (VIEW_AS_GRID):
        return (
            <Action
                data-tip={i18n.showAll}
                onClick={() => {
                    const previewMode = isPreviewMode();
                    if (previewMode !== false) {
                        setStateValue(previewMode, false);
                    }
                    setStateValue('currentViewMode', VIEW_MODE.GRID);
                }}
                {...rest}
            >
                {children}
            </Action>
        );
    case (VIEW_CALENDAR):
        return (
            <Action
                data-tip={i18n.calendar.preview}
                onClick={(e) => setViewMode(e, 'calendarViewMode')}
            >
                {children}
            </Action>
        );
    case (VIEW_IMAGE):
        return (
            <Action
                data-tip={i18n.viewImage}
                onClick={(e) => setViewMode(e, 'imgViewMode')}
            >
                {children}
            </Action>
        );
    case (VIEW_PDF):
        return (
            <Action
                data-tip={i18n.viewPdf}
                onClick={(e) => setViewMode(e, 'pdfViewMode')}
            >
                {children}
            </Action>
        );
    case (VIEW_ZIP):
        return (
            <Action
                data-tip={i18n.zipViewer.showContent}
                onClick={(e) => setViewMode(e, 'zipViewMode')}
            >
                {children}
            </Action>
        );
    case (DOWNLOAD_ALL):
        return (
            <Action
                data-tip={i18n.downloadAll}
                onClick={handleDownloadClick}
                {...rest}
            >
                {children}
            </Action>
        );
    default: // Download
        return (
            <Action
                data-tip={i18n.download}
                onClick={handleDownloadClick}
                {...rest}
            >
                {children}
            </Action>
        );
    }
};

ItemAction.propTypes = {
    actionName: PropTypes.string.isRequired,
    children: PropTypes.node
};

export default ItemAction;
